"use client";

import { c as _c } from "react/compiler-runtime";
import { FacebookIconAlt, GoogleIconAlt } from "@/components/fancy/social-icons";
import { Button } from "@/components/ui/button";
import { capturePixelEvent } from "@/lib/pixel";
import { useSignIn, useSignUp } from "@clerk/nextjs";
import { OAuthStrategy } from "@clerk/types";
import { useSearchParams } from "next/navigation";
export default function OAuthFlow() {
  const $ = _c(22);
  const {
    signUp,
    setActive
  } = useSignUp();
  const {
    signIn
  } = useSignIn();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("redirect_url") || "/";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const redirectUrl = t0;
  let t1;
  if ($[2] !== redirectUrl || $[3] !== setActive || $[4] !== signIn || $[5] !== signUp) {
    t1 = async function handleOAuthSignIn(strategy) {
      if (!signIn || !signUp) {
        return null;
      }
      const userExistsButNeedsToSignIn = signUp.verifications.externalAccount.status === "transferable" && signUp.verifications.externalAccount.error?.code === "external_account_exists";
      if (userExistsButNeedsToSignIn) {
        const res = await signIn.create({
          transfer: true
        });
        if (res.status === "complete") {
          setActive({
            session: res.createdSessionId
          });
        }
      }
      const userNeedsToBeCreated = signIn.firstFactorVerification.status === "transferable";
      if (userNeedsToBeCreated) {
        const res_0 = await signUp.create({
          transfer: true
        });
        if (res_0.status === "complete") {
          capturePixelEvent("CompleteRegistration", {
            method: strategy
          });
          setActive({
            session: res_0.createdSessionId
          });
        }
      } else {
        signIn.authenticateWithRedirect({
          strategy,
          redirectUrl: "/sso-callback",
          redirectUrlComplete: redirectUrl
        });
      }
    };
    $[2] = redirectUrl;
    $[3] = setActive;
    $[4] = signIn;
    $[5] = signUp;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleOAuthSignIn = t1;
  let t2;
  if ($[7] !== handleOAuthSignIn) {
    t2 = () => handleOAuthSignIn("oauth_google");
    $[7] = handleOAuthSignIn;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GoogleIconAlt size={20} />;
    t4 = <p>Continue with Google</p>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2) {
    t5 = <Button variant="outline" onClick={t2} className="flex items-center gap-4 py-8">{t3}{t4}</Button>;
    $[11] = t2;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== handleOAuthSignIn) {
    t6 = () => handleOAuthSignIn("oauth_facebook");
    $[13] = handleOAuthSignIn;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FacebookIconAlt size={20} />;
    t8 = <p>Continue with Facebook</p>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6) {
    t9 = <Button variant="outline" onClick={t6} className="flex items-center gap-4 py-8">{t7}{t8}</Button>;
    $[17] = t6;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <div className="flex flex-col gap-2">{t5}{t9}</div>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}